
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seminar/entry/form",
      function () {
        return require("private-next-pages/seminar/entry/form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seminar/entry/form"])
      });
    }
  